import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/esnext.map.delete-all.js";
import "core-js/modules/esnext.map.every.js";
import "core-js/modules/esnext.map.filter.js";
import "core-js/modules/esnext.map.find.js";
import "core-js/modules/esnext.map.find-key.js";
import "core-js/modules/esnext.map.includes.js";
import "core-js/modules/esnext.map.key-of.js";
import "core-js/modules/esnext.map.map-keys.js";
import "core-js/modules/esnext.map.map-values.js";
import "core-js/modules/esnext.map.merge.js";
import "core-js/modules/esnext.map.reduce.js";
import "core-js/modules/esnext.map.some.js";
import "core-js/modules/esnext.map.update.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default defineComponent({
  props: {
    sections: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    questionnaireResultMapping: {
      type: Object,
      default: function _default() {}
    }
  },
  setup: function setup() {},
  methods: {
    selectedOptions: function selectedOptions(section) {
      var result = this.questionnaireResultMapping[section.label];
      if (!result) return [];
      return result.details.questionDetails.filter(function (e) {
        return e.hasRisk === true;
      }).flatMap(function (e) {
        return e.options;
      });
    },
    getViolations: function getViolations(section) {
      var _result$details;
      var result = this.questionnaireResultMapping[section.label];
      if ((result === null || result === void 0 ? void 0 : (_result$details = result.details) === null || _result$details === void 0 ? void 0 : _result$details.hasRisk) === true) {
        var counts = new Map();
        var optionIxIds = {};
        section.questions.flatMap(function (question) {
          return question.options;
        }).forEach(function (option) {
          if (option.id) {
            optionIxIds[option.id] = option.ixId;
          }
        });
        this.selectedOptions(section).forEach(function (option) {
          counts.set(option.label, (counts.get(option.label) || 0) + 1);
        });
        return Array.from(counts).map(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
            violation = _ref2[0],
            count = _ref2[1];
          return (count > 1 ? count + ' x ' : '') + violation;
        });
      }
      return [this.$t('general.nothingToDisclose')];
    }
  }
});